import * as React from 'react';
import NewsPage from './Components/NewsPage';
import { Component } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { HashRouter as Router, Link, Route, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Layout, Menu, Breadcrumb } from 'antd';
import 'antd/dist/antd.css';
import './index.css';
import '../images/logo_cut.jpg';
import { VerticalAlignBottomOutlined } from '@ant-design/icons/lib';
import Verkauf from './Components/Verkauf';
import { Main } from './classes/Main';
import CompanyHistory from './Components/History';
import Team from './Components/Team';
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from 'react-bootstrap';
import OpeningHours from "./Components/OpeningHours";
import Contact from "./Components/Contact";
import MaschinenVerkauf from "./Components/MaschinenVerkauf";
import Lager from "./Components/Lager";
import Werkstatt from "./Components/Werkstatt";
import Uebergaben from "./Components/Uebergaben";
import FooterPage from "./Components/FooterPage";
import Impressum from "./Components/Impressum";

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
let main = null;

autorun(() => {
  //console.log("CardNumber " + game.currentCardNumber + ", CardType " + game.currentCardType + " ,Score " + game.score);
  //console.log(game.decks);
  main = new Main();
});

@observer
export default class App extends React.Component {

  constructor(props) {
    super(props);
    this.setNavExpanded = this.setNavExpanded.bind(this);
    this.closeNav = this.closeNav.bind(this);
  }

 state = {
    navExpanded: false,
  };




  setNavExpanded() {
    if(this.state.navExpanded == true){
      this.setState({ navExpanded: false });
    }else{
      this.setState({ navExpanded: true });
    }

  }

  closeNav() {
    this.setState({ navExpanded: false });
  }

  render() {
    return (
      <Router>
          <div className="row">
            <div className="col-md-12">
              <Navbar onToggle={this.setNavExpanded} expanded={this.state.navExpanded} bg="light" variant="light" expand="xl" sticky="top">
                <Navbar.Brand><Link to="/Home"><img
                    src="./images/logo_cut.jpg"
                    className="d-inline-block align-top logo_starpage"
                    alt="Mehele Landtechnik"
                /></Link>

                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbar-collapse" />
                <Navbar.Collapse id="navbar-collapse">
                  <Nav className="mr-auto">
                    <Link onClick={this.closeNav} to="/" className="nav-link aktionen_fade_in">
                      Home
                    </Link>
                    <Link to="/Neumaschinen" onClick={this.closeNav} className="nav-link neumaschinen_fade_in">
                      Neumaschinen
                    </Link>
                    <Link to="/Verkauf" onClick={this.closeNav} className="nav-link gebrauchte_fade_in">
                      Gebrauchtmaschinen
                    </Link>
                    <NavDropdown id="/leistungen" title="Leistungen" className="leistungen_fade_in">
                      <NavDropdown.Item>
                        <Link to="/Ersatzteillager" onClick={this.closeNav} className="nav-link dropdown_link fade_in_lvl_two">
                          Ersatzteillager
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/Werkstätte" onClick={this.closeNav} className="nav-link dropdown_link fade_in_lvl_three">
                          Werkstätte
                        </Link>
                      </NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown id="unternehmen" title="Unternehmen" className="unternehmen_fade_in">
                      <NavDropdown.Item>
                        <Link to="/Geschichte" onClick={this.closeNav} className="nav-link dropdown_link fade_in_lvl_one">
                          Geschichte
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                        <Link to="/Team" onClick={this.closeNav} className="nav-link dropdown_link fade_in_lvl_two">
                          Team
                        </Link>
                      </NavDropdown.Item>
                        <NavDropdown.Item>
                        <Link to="/Öffnungszeiten" onClick={this.closeNav} className="nav-link dropdown_link fade_in_lvl_three">
                          Öffnungszeiten
                        </Link>
                        </NavDropdown.Item>
                          <NavDropdown.Item>
                        <Link to="/Kontakt" onClick={this.closeNav} className="nav-link dropdown_link fade_in_lvl_four">
                          Kontakt
                        </Link>
                      </NavDropdown.Item>
                    </NavDropdown>
                    <Link to="/Übergaben" onClick={this.closeNav} className="nav-link übergaben_fade_in">
                      Übergaben
                    </Link>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
              <Switch>
                <Route path="/Verkauf">
                  <Verkauf />
                </Route>
                <Route
                  exact
                  path="/Geschichte"
                  render={() => (
                    <CompanyHistory historyList={main.History.historyList} />
                  )}
                />
                <Route
                    exact
                    path="/Impressum"
                    render={() => (
                        <Impressum></Impressum>
                    )}
                />
                <Route
                  exact
                  path="/Team"
                  render={() => (
                    <Team employeeList={main.Employee.employeeList} />
                  )}
                ></Route>
                <Route
                    exact
                    path="/Öffnungszeiten"
                    render={() => (
                      <OpeningHours hours={main.OpeningHours.hours} ></OpeningHours>
                    )}
                ></Route>
                <Route
                    exact
                    path="/Kontakt"
                    render={() => (
                        <Contact></Contact>
                    )}
                ></Route>
                <Route
                    exact
                    path="/Neumaschinen"
                    render={() => (
                        <MaschinenVerkauf></MaschinenVerkauf>
                    )}
                ></Route>
                <Route
                  exact
                  path="/Ersatzteillager"
                  render={() => (
                      <Lager></Lager>
                  )}
              ></Route>
                <Route
                    exact
                    path="/Werkstätte"
                    render={() => (
                        <Werkstatt></Werkstatt>
                    )}
                ></Route>
                <Route
                    exact
                    path="/Übergaben"
                    render={() => (
                        <Uebergaben ubergaben={main.Uebergaben.ubergabenList}></Uebergaben>
                    )}
                ></Route>
                <Route
                    path="/"
                    render={() => <NewsPage newsItem={main.News} />}
                />
              </Switch>
            </div>
          </div>
        <FooterPage/>
      </Router>
    );
  }
}
